<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': permissions.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Permission list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Code') }}</th>
            <th scope="col">{{ i18n('Name') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <PermissionListItem v-for="permission in permissions" :permission="permission" :key="permission.id"
            @edit="showPermissionModal" @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" :application="application" />
          <EmptyListItem v-if="!permissions || permissions.length == 0" :loading="loading" :colspan="7" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)" :autoLazyLoad="autoLazyLoad" :colspan="7"
            @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
  </div>
  <PermissionModal ref="PermissionModal" @updated="$emit('updated', $event)" :application="application" />
</template>

<script>
import PermissionListItem from "@/components/permission/PermissionListItem.vue";
import PermissionModal from "@/components/permission/PermissionModal.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    PermissionListItem,
    PermissionModal,
    EmptyListItem,
    LazyLoadListItem,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
  ],
  props: {
    application: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    permissions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    showPermissionModal(permission) {
      if (!this.$refs.PermissionModal) return;
      this.$refs.PermissionModal.show(permission.id);
    },
  },
};
</script>